import { FormEvent, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { getElementFromId } from "../../../components/funcForInput";
import removeAllErrorMsg from "../../../components/funcRemoveAllErros";
import LoadingModal from "../../../components/loadingModal";
import { ApiEndpoints, reqPatch, reqPostNew, reqPut } from "../../../config/apiClient";
import { getCookie } from "../../../config/cookies";
import { getUrlSearchParams } from "../../urlParams";
import ModalDocumentoRenomear from "../documento/ModalDocumentoRenomear";
import { signatarioDadosDto } from "./signatarios.dto";
import funcSleep from "../../../components/funcSleep";
import "pdfjs-dist/build/pdf.worker.mjs";
import "./styles.css";
import DocumentoTitulo from "./DocumentoTitulo";
import FormUploadDocumento from "./FormUploadDocumento";
import RenderSignatarios from "./RenderSignatarios";
import { useDispatch, useSelector } from "react-redux";
import { setDocumentoDados } from "../documentosSlice";
import $ from "jquery";
import "jquery-mask-plugin";
import RenderDocumentos from "./RenderDocumentos";
import FormFinalizarDocumento from "./FormFinalizarDocumento";

export default function DocumentoNovoPage() {
    // Dados
    const documentoDados = useSelector((state: any) => state.uiDocumentos.documentoDados);
    const dispatch = useDispatch();

    // Interface
    const [modalLoading, setShowModalLoading] = useState<boolean>(false);
    const [modalRenomear, setShowModalRenomear] = useState<boolean>(false);
    const [UIPrimaryDiv, setUIPrimaryDiv] = useState<string>("vazio");

    useEffect(() => {
        defineMaskInputs();
        const urlDados = getUrlSearchParams();
        const documento_codigo = urlDados.get("codigo");
        if (documento_codigo !== null) {
            consultarDocumento(documento_codigo);
        }
        // eslint-disable-next-line
    }, []);

    async function consultarDocumento(codigo: string) {
        let dados = { codigo };
        const api = await reqPostNew(ApiEndpoints.documentoDados, dados);
        if (api.status === 200) {
            const documento = api.data;
            await renderDocumento(documento);
        }
    }
    async function renderDocumento(documento: any) {
        document.title = `NOVO ${documento.nome} | OB PORTUS APP`;
        dispatch(setDocumentoDados({ documento: documento }));
        await funcSleep(500);
        setUIPrimaryDiv("signatarios");
        // console.log(`dados_documento`)
        // console.log(documento.assinaturas)
    }

    async function criarDocumento() {
        removeAllErrorMsg();
        const form: any = getElementFromId("formNovoDocumento");
        if (Object.values(documentoDados).length > 0) {
            return;
        }
        let arquivos_selecionados = form.documento.files;
        if (arquivos_selecionados.length === 0) {
            form.documento_aux.nextElementSibling.style.display = "block";
            return;
        }

        const urlDados = getUrlSearchParams();
        const id_pasta = urlDados.get("pasta");
        let documento = form.documento.files[0];
        let dadosDocumento = {
            nome: documento.name,
            extensao: "pdf",
            id_pasta: id_pasta === null ? "0" : String(id_pasta),
            id_usuario: String(getCookie("id_user")),
            documento: documento,
        };

        const token = getCookie("token");
        const id_usuario = getCookie("id_user");
        let dados = new FormData();
        dados.append("documento", dadosDocumento.documento);
        dados.append("nome", dadosDocumento.nome);
        dados.append("extensao", dadosDocumento.extensao);
        dados.append("id_pasta", dadosDocumento.id_pasta);
        dados.append("id_usuario", dadosDocumento.id_usuario);

        setShowModalLoading(true);
        try {
            let api: Response;
            let apiData = await fetch(ApiEndpoints.documentoCriar.endpoint, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                    id_usuario: id_usuario,
                },
                body: dados,
            }).then((response) => {
                api = response;
                return response.json();
            });

            if (api!.status === 201) {
                toast.success("Documento criado com sucesso!", {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                });
                urlDados.set("documento", apiData.codigo);
                window.history.pushState("OB PORTUS .NET", "OB PORTUS DOCUMENTOS", `/documento/novo?codigo=${apiData.codigo}`);
                renderDocumento(apiData);
            } else {
                toast.warn(String(apiData.message), {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                });
            }
        } catch (error) {
            console.log(error);
            toast.warn("Não foi possível enviar o documento!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }
        setShowModalLoading(false);
    }
    async function handleRenomear(dados: any) {
        setShowModalRenomear(false);
        setShowModalLoading(true);
        const api = await reqPatch(ApiEndpoints.documentoRenomear, dados);
        if (api.status === 200) {
            toast.success(`Nome editado com sucesso!`, {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await consultarDocumento(dados.codigo);
        }
        setShowModalLoading(false);
    }
    function handleSubmit(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        event.stopPropagation();
        removeAllErrorMsg();

        // const form: any = event.target
        let formValidado = true;

        if (!formValidado) {
            return;
        }
    }
    async function salvarSignatarios(signatarios: signatarioDadosDto[], openAssinaturas:boolean) {
        setShowModalLoading(true);
        const api = await reqPatch(ApiEndpoints.documentoCriarSignatarios, {
            codigo: documentoDados.codigo,
            signatarios,
        });
        if (api.status === 200) {
            if (!openAssinaturas) { 
                toast.success("Signatários salvos com sucesso!", {
                    containerId: 1,
                    position: "top-center",
                    theme: "dark",
                    autoClose: 1000,
                });
            }
            // renderDocumento(api.data);
            dispatch(setDocumentoDados({ documento: api.data }));
            if (openAssinaturas) { 
                setUIPrimaryDiv("assinaturas")
            }
        }
        setShowModalLoading(false);
    }
    async function salvarAssinaturas(assinaturasDados: any[]) {
        setShowModalLoading(true);
        const dados = {
            codigo: documentoDados.codigo,
            assinaturas: assinaturasDados,
        };
        // console.log(`editar_assinaturas`)
        // console.log(assinaturasDados)
        const api = await reqPut(ApiEndpoints.documentoCriarAssinaturas, dados);
        if (api.status === 201) {
            toast.success("Assinaturas salvas com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            await renderDocumento(api.data.documento);
        }
        setShowModalLoading(false);
    }

    return (
        <div id="main">
            <LoadingModal
                show={modalLoading}
                handleClose={(event: any) => {
                    setShowModalLoading(!modalLoading);
                }}
            />
            <ModalDocumentoRenomear
                show={modalRenomear}
                documento={documentoDados}
                handleClose={() => {
                    setShowModalRenomear(false);
                }}
                handleRenomear={handleRenomear}
            />

            <div id="div_novo_documento_page">
                <DocumentoTitulo documentoDados={documentoDados} handleOpenModalRenomear={() => setShowModalRenomear(true)} />

                <br></br>
                <Form id="formNovoDocumento" onSubmit={handleSubmit} noValidate>
                    <Form.Control name="cpf_aux" type="text" id="cpf_aux" className="cpf" style={{ display: "none" }} />
                    <Form.Control name="telefone_aux" type="text" id="telefone_aux" className="telefone" style={{ display: "none" }} />
                    <Form.Control name="div_selecionada_aux" type="text" id="div_selecionada_aux" style={{ display: "none" }} />

                    <FormUploadDocumento documentoDados={documentoDados} handleCriarDocumento={() => criarDocumento()} />

                    <br></br>

                    {UIPrimaryDiv === "signatarios" && <RenderSignatarios handleUpdate={(dados: any[], openAssinaturas:boolean) => salvarSignatarios(dados, openAssinaturas)} handleFinalizar={() => setUIPrimaryDiv("finalizar")} />}
                    {UIPrimaryDiv === "assinaturas" && <RenderDocumentos handleUpdate={(dados: any[]) => salvarAssinaturas(dados)} handleLoadingStatus={(status:boolean) => setShowModalLoading(status)} />}
                    {UIPrimaryDiv === "finalizar" && <FormFinalizarDocumento documentoDados={documentoDados} handleVoltar={() => setUIPrimaryDiv("signatarios")} />}
                </Form>
            </div>
        </div>
    );
}
function defineMaskInputs() {
    $(".cpf").mask("000.000.000-00", {
        reverse: false,
        placeholder: "###.###.###-##",
    });
    $(".telefone").mask("(00) 00000-0000", {
        reverse: false,
        placeholder: "(##) #####-####",
    });
}
